import { Redirect } from "react-router";
import { routes } from "../../../app/routes";
import { RouteComponentProps } from "react-router-dom";
import { SessionType } from "@app/shared/types";

export const DropInSessionRoute = ({ location }: RouteComponentProps) => {
    const queryParams = new URLSearchParams(location.search);
    const communityEventId = queryParams.get("communityEventId");
    const sessionType = queryParams.get("sessionType");

    if (!communityEventId) {
        return <Redirect to={routes.memberHomePage()} />;
    }

    // catching legacy links (hardcoding the only existing talk and redirecting all other links to meditations page)
    if (communityEventId === "vdZ2ZLKSCqNe3UDvBEnm") {
        return <Redirect to={`/member/drop-in/talks?communityEventId=${communityEventId}`} />;
    }

    if (sessionType === SessionType.COMMUNITY_TALK) {
        return <Redirect to={`/member/drop-in/talks?communityEventId=${communityEventId}`} />;
    } else {
        return (
            <Redirect
                to={`/member/drop-in/meditations?communityEventId=${communityEventId}`}
            />
        );
    }
};
